const getDeviceInfo = () => {
  return {
    // buildNumber: 13,
    // deviceIOSVersion: '14.6',
    // deviceModel: 'iPhone',
    // deviceName: 'Alex’s iPhone',
    // deviceUid: '0C38D5D0-FC54-4359-A646-A505F4A04DE7',
    // version: '1.0.2',
    buildNumber: 1,
    deviceIOSVersion: '',
    deviceModel: navigator.platform,
    deviceName: navigator.appVersion,
    deviceUid: '',
    version: process.env.REACT_APP_VERSION,
  };
};

export default getDeviceInfo;
